/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { adresseSuggestionSchema } from "../adresseSuggestionSchema.ts";
import { z } from "zod";

export const findAdresseProcheQueryParamsSchema = z.object({
      "latitude": z.coerce.number().min(-90).max(90),
  "longitude": z.coerce.number().min(-180).max(180)
      })

/**
 * @description L\'adresse la plus proche, ou une liste vide si aucune n\'est connue à proximité ou si le géocodeur est indisponible.
 */
export const findAdresseProche200Schema = z.array(z.lazy(() => adresseSuggestionSchema).describe("Adresse proposée par le géocodeur de la Base Adresse Nationale."))

export const findAdresseProcheQueryResponseSchema = z.lazy(() => findAdresseProche200Schema)